import React from 'react';
import classnames from 'classnames'
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';

class CeeDecision extends React.Component {
    render() {
        return (
            <React.Fragment>
                <p style={{ marginTop: "auto", marginBottom: "1em" }}>
                    <Translate id='Search.Cee.Decision' data={{ date: this.props.requestDate }} />
                </p>
                <div className="modal-inner-buttons">
                    <button type='button' onClick={() => this.props.continue()} className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id='Common.Continue' />
                    </button>
                    <button type='button' onClick={() => this.props.newRequest()} className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id='Search.Cee.NewRequest' />
                    </button>
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(CeeDecision);